module.exports = __webpack_public_path__ + "img/evalutor.39710c89.svg";